import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../../components/Layout/LoginLayout/LoginLayout';
import './style.css';

import iconUsername from '../../assets/profile.png';
import iconPassword from '../../assets/padlock.png';
import iconVisible from '../../assets/visible.png';
import iconHide from '../../assets/hide.png';
import { useEffect, useState } from 'react';

import LoginService from './LoginService';
import { LoginRequest, LoginResponse } from '../../interface/ILogin';

function Login() {
	const navigate = useNavigate();
	const [loginRequest, setLoginRequest] = useState<LoginRequest>({ Username: '', Password: '' });
	const [loginResponse, setLoginResponse] = useState<LoginResponse | null>(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);

	const usernameInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		setLoginRequest((prevRequest) => ({
			...prevRequest,
			[name]: value,
		}));
	};

	const passwordInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		setLoginRequest((prevRequest) => ({
			...prevRequest,
			[name]: value,
		}));
	};

	const LoginButtonClick = async () => {
		document.querySelector('.login-main')?.classList.add('loader');
		try {
			const response = await LoginService.Login(loginRequest);
			if (response.status >= 200 && response.status < 300) {
				setLoginResponse(response.data);
				document.querySelector('.login-main')?.classList.remove('loader');
			} else {
				throw new Error(response.data.message);
			}
		} catch (error) {
			const dvMessage = document.getElementById("dvMessage");
			if (dvMessage instanceof HTMLElement) {
				dvMessage.classList.add("active");
			}

			if (axios.isAxiosError(error)) {
				if (error.code === 'ERR_NETWORK') {
					setErrorMessage('Network Error: Unable to connect to the server.');
				} else if (error.response) {
					setErrorMessage(error.response.data.message || 'An error occurred');
				} else {
					setErrorMessage('An error occurred while processing your request.');
				}
			} else {
				setErrorMessage(String(error));
			}
		} finally {
			document.querySelector('.login-main')?.classList.remove('loader');
			setLoginRequest({ Username: '', Password: '' });
		}
	};

	const DeleteCookiesToken = async () => {
		try {
			const response = await LoginService.DeleteToken();
			await LoginService.DeleteCookies();
		} catch (error) {
			if (axios.isAxiosError(error)) {
				console.log('axios error:: ', error.response?.data.message);
			} else {
				console.log("Error:: ", error);
			}
		}
	};

	const passwordToggleClick = () => {
		setIsPasswordVisible(!isPasswordVisible);
	};

	const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
		// document.querySelector('.login-main')?.classList.add('loader');
		if (event.key === 'Enter') {
			LoginButtonClick(); // Trigger login when Enter is pressed
		}
	};

	useEffect(() => {
		window.addEventListener('load', DeleteCookiesToken);

		if (loginResponse != null) {
			const expirationToken = new Date(loginResponse.result.refreshTokenExpiration);
			LoginService.SetLoginToken(loginResponse.result.refreshToken, expirationToken, loginResponse.result.username, loginResponse.result.permission, loginResponse.result.role);
			navigate("/Admin/Dashboard");
		}
	}, [loginResponse]);

	return (
		<Layout>
			<div className="login-form ">
				<div id="dvMessage" className="left-align font-size-17px">
					{errorMessage}
				</div>
				<div className="font-green">
					<h1>Login</h1>
				</div>

				<div className="icon-container">
					<span className="icon-login">
						<img src={iconUsername} className="responsive-image" />
					</span>
					<input
						type="text"
						className="textbox-green-350px"
						name="Username"
						id="txtUsername"
						placeholder="Username or Email"
						value={loginRequest.Username}
						onChange={usernameInputChange}
						onKeyPress={handleKeyPress} // Add event listener for Enter key
					/>
				</div>

				<div className="icon-container">
					<span className="icon-login">
						<img src={iconPassword} className="responsive-image" />
					</span>
					<input
						type={isPasswordVisible ? "text" : "password"}
						className="textbox-green-350px"
						id="txtPassword"
						name="Password"
						placeholder="Password"
						value={loginRequest.Password}
						onChange={passwordInputChange}
						onKeyPress={handleKeyPress} // Add event listener for Enter key
					/>
					{!isPasswordVisible ? (
						<span className="toggle-password" onClick={passwordToggleClick}>
							<img src={iconVisible} className="responsive-image" />
						</span>
					) : (
						<span className="toggle-password" onClick={passwordToggleClick}>
							<img src={iconHide} className="responsive-image" />
						</span>
					)}
				</div>

				<div className="">
					<Link className="font-black" to='/Admin/ForgotPassword'>Forgot Password?</Link>
				</div>

				<div className="center-middle">
					<button
						type="submit"
						id="btnLogin"
						onClick={LoginButtonClick}
						className="btn-green-100 center-middle"
					>
						Sign in
					</button>
				</div>
			</div>
		</Layout>
	);
}

export default Login;
